<template lang="pug">
  .post(
    ref="post"
    :class="classFoundedOnTrust"
  )
    .overlay(@click="showPopUp = false" v-if="showPopUp")
    .pop-up(v-if="showPopUp")
      .pop-up__close(@click="showPopUp = false") X
      .pop-up__message Показать комментарии при печати?
      .pop-up__btn.pop-up__btn--no(@click="() => {showComments = false; printPost();}") Нет
      .pop-up__btn.pop-up__btn--yes(@click="showCommentsAction(), printPost()") Да
    post-header(:post="post" @printPostAction="printPostAction")
    .post-body__outer
      post-body(:text="post.text" :network="post.network_name")
    post-repost(:post="post.repost" v-if="Object.keys(post.repost).length")
    .post-comments(v-if="post.comments !== '0'")
      .post-comments-count
        img.post-comments-count__icon(src="../../assets/images/icon-comment.svg")
        span.post-comments-count__count {{ post.comments }}
        span.post-comments-count__show.no-print(
          @click="showCommentsAction"
        ) {{ showComments ? 'Скрыть комментарии' : 'Показать комментарии' }}
      template(v-if="showComments")
        table-preloader(v-if="reqPending")
        post-comment(v-for="comment in commentaries" :comment="comment")
        span.post-comments-count__show.no-print(
          @click="showComments = !showComments"
          style="margin-top: 1em; margin-left: 3.4em;"
        ) Скрыть комментарии
        .button-wrap
          span.post-comments-count__show-more(
          v-if="showButton"
          @click="getMoreComments"
          ) Показать еще
</template>

<script>
import { getCommentsApi } from '@/api/posts';
import PostHeader from '@/components/posts/postHeader.vue';
import PostBody from '@/components/posts/postBody.vue';
import PostComment from '@/components/posts/postComment.vue';
import PostRepost from '@/components/posts/postRepost.vue';
import PostReComment from '@/components/posts/postReComment.vue';
import PostImages from "@/components/posts/postImages.vue";
import TablePreloader from "@/components/preLoaders/tablePreloader";

export default {
  name: 'post',
  components: {
    TablePreloader,
    PostImages,
    PostReComment,
    PostRepost,
    PostComment,
    PostBody,
    PostHeader,
  },
  props: {
    itemIndex: {
      type: Number,
      default: 0,
    },
    post: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showComments: false,
      showMoreComments: false,
      commentaries: '',
      reqPending: false,
      showPopUp: false,
      start: 0,
      limit: 30,
      count: 0,
      showButton: true,
    };
  },
  computed: {
    classFoundedOnTrust() {
      const trust = this.post.trust.trust;
      return trust === -1 ? 'post--negative' : trust === 0 ? 'post--neutral' : trust === 1 ?
        'post--positive' : '';
    },
  },
  methods: {
    getMoreComments() {
      this.showComments = !this.showComments;
      this.showCommentsAction();
    },
    printPostAction() {
      if (this.post.comments !== '0') {
        this.showPopUp = true;
      } else {
        this.printPost();
      }
    },
    printPost() {
      new Promise((resolve, reject) => {
        if (this.$refs.post.querySelector('.post-body__content--trim')) {
          this.$refs.post.querySelector('.post-body__content--trim').click();
        }
        this.showPopUp = false;
        setTimeout(() => {
          resolve();
        }, 1000);

      })
        .then(() => {
          let source = this.$refs.post.innerHTML;
          let head = document.head.innerHTML;
          var mywindow = window.open('', 'PRINT', 'height=400,width=600');

          mywindow.document.write('<html><head>' + head);
          mywindow.document.write('</head><body >');
          mywindow.document.write(source);
          mywindow.document.write('</body></html>');
          mywindow.document.close(); // necessary for IE >= 10
          mywindow.focus(); // necessary for IE >= 10*/

          setTimeout(() => {
            mywindow.print();
            mywindow.close();
          }, 1000);

          return true;
        });
    },
    showCommentsAction() {
      if (!this.showComments) {
        this.reqPending = true;
        this.showComments = !this.showComments;
        const params = {
          limit: this.limit,
          network_id: this.post.network_id,
          owner_id: this.post.owner_id,
          post_id: this.post.id,
          start: this.start,
          thread_id: process.env.VUE_APP_THREAD_ID,
        };
        getCommentsApi(params)
          .then((resp) => {
            this.commentaries = [...this.commentaries, ...resp.data.commentaries];
            this.count = this.commentaries.length;

            if (this.count < this.limit || this.count === parseInt(resp.data.count, 10)) {
              this.showButton = false;
            }

            this.start = this.commentaries.length;
            this.reqPending = false;
          })
          .catch((err) => {
            this.reqPending = false;
            return err;
          });
      } else {
        this.showComments = !this.showComments;
      }
    },
  },
};
</script>

<style lang="stylus">
.post
  display flex
  flex-direction column
  width 90%
  margin 0 auto 1em
  position relative
  border 4px solid transparent
  @media screen and (max-width 800px)
    width 100%
    margin 0
    border-bottom 1px solid #ccc
  &--negative
    border 4px solid #ed8282
  &--neutral
    border 4px solid #888
  &--positive
    border 4px solid #81ea89
  &__print
    width 1.5em
    height 1.5em
    cursor pointer
    margin-left 1em
  &-body__outer
    display flex
    width 100%
    margin 1em 0 0
    align-items flex-start
  &-comments
    border-top 1px solid #ccc
    width 100%
    margin-top 0
    padding 1em 0 0
    &-count
      display flex
      align-items center
      cursor pointer
      margin-bottom 1em
      &__icon
        width 1.4em
        hieght 1.4em
        margin 0 1em 0 0
      &__show
        display inline-block
        margin-left 1em
        font-weight bold
        color #460303
        cursor pointer
.button-wrap
  width 100%
  padding 20px
  display flex
  justify-content center
.post-comments-count__show-more
  font-weight bold
  color #460303
  cursor pointer
</style>
